import { render, staticRenderFns } from "./remain.vue?vue&type=template&id=13ea246f&scoped=true&"
import script from "./remain.vue?vue&type=script&lang=js&"
export * from "./remain.vue?vue&type=script&lang=js&"
import style0 from "./remain.vue?vue&type=style&index=0&id=13ea246f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea246f",
  null
  
)

export default component.exports